import React from "react";
import { Redirect } from "react-router-dom";

import { Pagination } from "@graffer-inc/console-design-kit";

import { useAuthContextV2 } from "../../../../../auth-state";
import { KintoneExportSettingsListController } from "../../../../organisms/kintone-export/kintone-export-settings-list-controller";
import { KintoneExportSettingsListTable } from "../../../../organisms/kintone-export/kintone-export-settings-list-table";
import { useKintoneExportSettings } from "../page-hooks/kintone-export-settings/hook";
import { KintoneExportR } from "../routes";
import { KintoneExportTemplate } from "../template";

export const KintoneExportSettings: React.FC = () => {
  const { auth } = useAuthContextV2();
  const {
    kintoneExportSettings,
    page,
    setPage,
    lastPage,
    handleKintoneExportSettingRowClick,
    handleCreateKintoneExportSetting,
  } = useKintoneExportSettings({
    tenantId: auth.data?.orgId,
    groupIds: auth.data?.groupIds,
    detailLinkProvider: KintoneExportR.KintoneExportSettingDetail.link,
    createLinkProvider: KintoneExportR.KintoneExportSettingCreate.link,
  });

  return (
    <KintoneExportTemplate
      breadcrumbs={[
        {
          to: KintoneExportR.KintoneExportSettings.link({}),
          title: "連携設定一覧",
        },
      ]}
    >
      <h1 className="title">連携設定一覧</h1>
      <KintoneExportSettingsListController
        onClickCreate={handleCreateKintoneExportSetting}
      />
      <KintoneExportSettingsListTable
        kintoneExportSettings={kintoneExportSettings}
        onRowClick={handleKintoneExportSettingRowClick}
      />
      <Pagination
        onPageClick={setPage}
        currentPage={page}
        lastPage={lastPage}
      />
    </KintoneExportTemplate>
  );
};

export const RedirectToKintoneExportSettings: React.FC = () => {
  return <Redirect to={KintoneExportR.KintoneExportSettings.link({})} />;
};
